export default "__VITE_ASSET__AQWFOqBt__"